<template>
    <evp-layout>
        <main>
            <router-view :key="$route.fullPath" />
        </main>
    </evp-layout>
</template>

<script setup>
    import EvpLayout from '@/components/EvpLayout.vue'
</script>
